<template>
  <div class="addr-box">
    <div>
      <van-form :show-error-message="false" validate-trigger="onChange" @submit="submit" @failed="failed">
        <div class="card-title">填写线路报价{{ $route.query.type === "start" ? "起点" : "终点" }}信息</div>
        <van-cell-group inset>
          <div class="detailedAddress-box" style="margin-top:20px;" @click="handleOpenSearch">
            <!-- <van-field
              :value="mapCenterInfo.detailedAddress"
              name=""
              placeholder=""
              class="input"
              disabled
            /> -->
            <div style="color: #3D3833;">您将<span style="color: #EC892E;">{{ mapCenterInfo.title }}</span>设为{{ $route.query.type === "start" ? "起点" : "终点" }}</div>
            <van-icon name="arrow" size="14px" color="#3D3833" style="margin-left: 16px;" />
          </div>
          <div class="input-box">
            <van-field
              v-model.trim="form.remark"
              name="详细地址"
              placeholder="请输入详细地址"
              class="input"
              :rules="[{ validator: specialCharacterValid, message: '不支持空格及特殊符号' , trigger:'onChange' }]"
              maxlength="50"
              @input="formChange"
            />
          </div>
          <div class="input-box">
            <van-field
              v-model.trim="form.realName"
              name="工厂名称"
              placeholder="请输入工厂名称"
              class="input"
              :rules="[
                { required: true , message:'请输入工厂名称' , trigger:'onChange' },
                { validator: specialCharacterValid, message: '不支持空格及特殊符号' , trigger:'onChange' }
              ]"
              maxlength="20"
              @input="formChange"
            />
          </div>
        </van-cell-group>
        <div class="footer">
          <van-button 
            round 
            type="warning" 
            color="linear-gradient(129deg, #F1892E 0%, #F1BC3F 100%)" 
            native-type="submit" 
            class="footer-button"
            :disabled="!mapLoaded||getCenterLoading"
          >{{ $route.query.id ? "确认修改线路" : "确认添加线路" }}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Image , Field , Cell , CellGroup , Form , Button , Toast , Checkbox, CheckboxGroup , Icon  } from 'vant';
export default {
  name:'dispatch-address-info',
  props:['mapCenterInfo','openSearch','isShowAddr','queryParams','mapLoaded','getCenterLoading','checkAddressObject'],
  components:{ 
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Icon.name]: Icon,
   },
  data(){
    return {
      form:{
        realName:'',
        remark:'',
        save:''
      },
    }
  },

  watch:{
    queryParams:{
      handler(val){
        this.form = this.deepClone(val)
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    /* 特殊字符校验 */
    specialCharacterValid(val){
      // return Promise.resolve(!/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\s]/im.test(val))
      return Promise.resolve(!/[`~!@#$%^&*_+=<>?:"{}|.\/;'\\[\]·~！@#￥%……&*——+={}|《》？：“”【】、；‘'。、\s]/im.test(val))
    },
    checkboxChange(value){
      this.formChange();
    },
    formChange(){
      this.$emit('update:queryParams',{
        ...this.queryParams,
        ...this.deepClone(this.form)
      })
    },
    handleOpenSearch(){
      this.$emit('update:openSearch',true);
    },
    submit(){
      window.uni.postMessage({
        data: this.queryParams
      });
      window.uni.navigateBack({
        delta:1
      })
    },
    failed({ errors }){
      Toast.fail(errors[0].message);
    }
  }
}
</script>

<style scoped lang="scss">
  .addr-box {
      box-sizing: border-box;
      position: relative;
      z-index: 99;
      background-color: #FFEAD8;
      & > div {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 0 12px;
        background-color: #FFF;
        overflow: hidden;
      }
      * {
        color: #130A01;
      }
      .van-form {
        position: relative;
        z-index: 100000;
        .van-cell-group {
          margin: 0;
        }
        .card-title {
          font-size: 16px;
          color: #3D3833;
          font-weight: bold;
          padding-top: 16px;
        }
        .detailedAddress-box {
          display: flex;
          align-items: center;
          font-size: 14px;
          margin-bottom: 24px;
          &:before {
            content: "";
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #EC892E;
            margin-right: 16px;
          }
        }
        .group-addr {
          padding-left: 0;
          padding: 15px 0;
        }
        .input-box {
          height: 48px;
          overflow: hidden;
          background-color: #F8F8F8;
          border-radius: 8px;
          display: flex;
          align-items: center;
          margin-bottom: 24px;
          ::v-deep .van-field__body {
            height: 100%;
          }
          .input {
            height: 48px;
            background-color: #F8F8F8;
            font-size: 16px;
          }
        }
        .footer {
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .footer-button {
            width: 100%;
            height: 48px;
            background: linear-gradient(179deg, #F1BC3F 0%, #EC892E 100%);
            box-shadow: 3px 8px 8px 1px rgba(255,122,0,0.2);
            border-radius: 8px;
            font-size: 16px;
            user-select: none;
            .van-button__text {
              font-family: 'DIN-Medium';
              color: #FFF;
            }
          }
        }
      }
    }
  ::v-deep .van-field__label {
    font-size: 16px;
    color: #1E1E1E;
  }
  ::v-deep .van-hairline--top-bottom {
    &:after {
      border: none;
    }
  }
  ::v-deep .van-checkbox {
    .van-checkbox__label {
      font-size: 13px;
      color: #130A01;
    }
  }
  ::v-deep .van-field__control:disabled {
    color: #333 !important;
    -webkit-text-fill-color:#333 !important;
  }
</style>